<!--
~ Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
-->
<ngf-dialog-title mat-dialog-title>
  Apply Template
</ngf-dialog-title>

<form [formGroup]="form" (ngSubmit)="selectTemplate()">
  <div mat-dialog-content>
    <ngf-control>
      <label>Template</label>
      <ngf-select [formControl]="form.controls.template" placeholder="Select a template">
        <ngf-options-container>
          @for (option of data.templates; track option) {
            <ngf-option
            [value]="option">{{option.name}}</ngf-option>
          }
        </ngf-options-container>
      </ngf-select>
      <ngf-control-error *ngfControlHasError="'required'">
        Select a template to apply
      </ngf-control-error>
    </ngf-control>
    <ngf-control>
      <ngf-checkbox aria-describedby="replaceTextHint" [formControl]="form.controls.replaceText">Replace Actual Content</ngf-checkbox>
      <ngf-control-hint id="replaceTextHint">Uncheck to append template content to the end of the existing content</ngf-control-hint>
    </ngf-control>
  </div>
  <div class="submit-actions" mat-dialog-actions>
    <button ngfButton="tertiary" mat-dialog-close>Cancel</button>
    <button ngfButton="primary" type="submit">Apply</button>
  </div>
</form>